import { useState, useContext, useEffect } from "react";
import { userAuthContext } from "../../ContextAPI/isAuth";
import { citiesContext } from "../../ContextAPI/Cities";
import { signin, signup } from "../../actions/auth";
import InputBox from "./InputBox";
import SelectBox from "./SelectBox";
import RadioButton from "./RadioButton";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader/Loader";
import ERROR from "../../component/ERROR/ERROR";
import { motion } from "framer-motion";
import "./styles.css";

import { notificationContext } from "../../ContextAPI/showNotification";

const initialState = {
  name: "",
  lastName: "",
  email: "",
  tel: "",
  password: "",
  confirmPassword: "",
  donator: "",
  bloodType: "",
  address: ""
};
const bloodType = ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"];

const Login = () => {
  const [notification, setNotification] = useContext(notificationContext);

  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useContext(userAuthContext);
  const cities = useContext(citiesContext);
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [isSignInCard, setIsSignInCard] = useState(true);
  const [province, setProvince] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleProvinceChange = (e) => {
    setProvince(e.target.value);
  };
  const switchSignIn = () => {
    setIsSignInCard((prev) => !prev);
  };

  const handleFormChange = (e) => {
    let { name, value } = e.target;
    if (name === "donator") {
      value = value === "Donateur" ? true : false;
    }
    setFormData((prev) => setFormData({ ...prev, [name]: value }));
  };
  const formValidation = (data) => {
    const error = {};
    const emailRegEx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const phoneRegEx = /^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/gm;

    if (!isSignInCard) {
      const {
        name,
        lastName,
        email,
        tel,
        password,
        confirmPassword,
        donator,
        bloodType,
        address
      } = data;
      if (name.length < 4 || name.length > 10) error.name = "Nom non valid";

      if (lastName.length < 4 || lastName.length > 10)
        error.lastName = "Prénom non valid";

      if (!emailRegEx.test(email)) error.email = "Email non valid";

      if (password.length < 8 || password.length > 40)
        error.password = "Veuillez entrer une pass supérieur à 8";

      if (confirmPassword !== password)
        error.confirmPassword = "Veuillez confirmer le mot de passe";

      if (typeof donator !== "boolean")
        error.donator = "Veuillez choisir un donateur ou un bénéficiaire";

      if (bloodType.length < 1)
        error.bloodType = "Veuillez choisir le group sanguin";
      if (address.length < 1)
        error.address = "Veuillez spécifier votre adderss";

      if (!phoneRegEx.test(tel)) error.tel = "Téléphone non valid";
    } else {
      const { email } = data;
      if (!emailRegEx.test(email)) error.email = "Email non valid";
    }

    return error;
  };
  class SubmitError extends Error {
    constructor(message) {
      super();
      this.message = message;
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSignInCard) {
      const validator = formValidation(formData);
      if (Object.keys(validator).length > 0) {
        setFormErrors(validator);
        return;
      }
      try {
        setIsLoading(null);
        const data = await signin(formData);

        if (!data) throw new Error("Connection Error");

        if (!data.success || typeof data.message === "string")
          throw new SubmitError(data.message);

        setIsLoading(false);
        localStorage.setItem("tkn", JSON.stringify(data.message));
        setIsAuth(true);
        navigate("../");
      } catch (error) {
        setIsLoading(false);

        if (error instanceof SubmitError) {
          setNotification((prev) => {
            return { ...prev, visible: true, message: error.message };
          });
        } else {
          setNotification((prev) => {
            return { ...prev, visible: true, message: error.message };
          });
        }
      }
    } else {
      const validator = formValidation(formData);

      if (Object.keys(validator).length > 0) {
        setFormErrors(validator);
        return;
      }
      try {
        setIsLoading(null); //Start Loading Animation
        const data = await signup(formData);
        setIsLoading(false);

        if (!data) throw new SubmitError("Erreur de conexion");

        //There is no error this is just for showing verification message
        throw new SubmitError({ success: data.success, data: data.message });
      } catch (error) {
        console.log("Ver Err", error);
        setIsLoading(false);
        if (error instanceof SubmitError) {
          setNotification((prev) => {
            return { ...prev, visible: true, message: error.message.data };
          });
          if (error.message.success) {
            navigate("/");
          }
        }
      }
    }
  };

  useEffect(() => {
    if (isAuth) {
      navigate("/");
    }
  }, [isAuth]);
  if (isAuth) return "ERROR 404";
  return (
    <motion.section
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      exit={{ opacity: 0 }}
      className="login"
    >
      <div className="container">
        <div className="login__container">
          <div className="login__form">
            <h2>{isSignInCard ? "S'inscrire" : "Rejoindre"}</h2>
            <form onChange={handleFormChange} onSubmit={handleSubmit}>
              {Object.keys(formErrors).length ? (
                <ERROR errorObject={formErrors} />
              ) : null}
              {isSignInCard ? null : (
                <>
                  <InputBox
                    label="Nom"
                    type="text"
                    name="name"
                    id="auth-name"
                  />
                  <InputBox
                    label="Prénom"
                    type="text"
                    name="lastName"
                    id="auth-last-name"
                  />
                </>
              )}
              <InputBox
                label="Email"
                type="email"
                name="email"
                id="auth-email"
              />
              <InputBox
                label="Mot de Passe"
                type="password"
                name="password"
                id="auth-password"
              />
              {isSignInCard ? null : (
                <>
                  <InputBox
                    label="Confirmer Mot de Passe"
                    type="password"
                    name="confirmPassword"
                    id="auth-confirm-password"
                  />
                  <InputBox
                    label="Téléphone"
                    type="tel"
                    name="tel"
                    id="auth-tel"
                  />
                  <SelectBox
                    name="bloodType"
                    id="auth-bloodType"
                    options={bloodType}
                    label="Choisir Groupe Sanguin"
                  />
                  <div className="auth__radio__donation">
                    <RadioButton name="donator" value="Donateur" />
                    <RadioButton name="donator" value="Bénéficiaire" />
                  </div>

                  <SelectBox
                    name="province"
                    id="auth-province"
                    options={Object.keys(cities)}
                    label="Province"
                    onChange={handleProvinceChange}
                  />
                  <SelectBox
                    name="address"
                    id="auth-city"
                    options={cities[province]}
                    label="Ville"
                  />
                </>
              )}

              <div className="login-btn">
                <button className="btn btn-primary">
                  <span>{isSignInCard ? "S'inscrire" : "Rejoindre"}</span>
                  {isLoading ?? <Loader />}
                </button>
              </div>
              <p>
                Vous {isSignInCard ? "n'est pas de" : "est un"} compte ?{" "}
                <a
                  onClick={switchSignIn}
                  style={{
                    color: "var(--color-primary)",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                >
                  {isSignInCard ? "Rejoindre" : "S'inscrire"}
                </a>
              </p>
              {isSignInCard ? (
                <p className="login__forgetPass">
                  <a>Mot Passe Oublier ? Click ici</a>
                </p>
              ) : null}
            </form>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
export default Login;
